import './dom-vertical-mini-map.css'
import DomVerticalMiniMap from './dom-vertical-mini-map'

export default DomVerticalMiniMap
